import {useCallback, useState} from 'react';

import {useGetTraceServerClientContext} from '../../wfReactInterface/traceServerClientContext';
import {
  ImageGenerationCreateReq,
  ImageGenerationCreateRes,
} from '../../wfReactInterface/traceServerClientTypes';

export interface ImageGenerationHookResult {
  generateImage: (
    req: ImageGenerationCreateReq
  ) => Promise<ImageGenerationCreateRes>;
  isGenerating: boolean;
  error: string | null;
}

export const useImageGenerationFunctions = (): ImageGenerationHookResult => {
  const getTsClient = useGetTraceServerClientContext();
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generateImage = useCallback(
    async (
      req: ImageGenerationCreateReq
    ): Promise<ImageGenerationCreateRes> => {
      setIsGenerating(true);
      setError(null);
      try {
        const result = await getTsClient().imageCreate(req);
        return result;
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : 'Unknown error occurred';
        setError(errorMessage);
        throw err;
      } finally {
        setIsGenerating(false);
      }
    },
    [getTsClient]
  );

  return {
    generateImage,
    isGenerating,
    error,
  };
};
